var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--cta",attrs:{"id":"modal-legal-overlay"}},[_c('h3',{staticClass:"no-border"},[_vm._v("\n        "+_vm._s(_vm.currentModalData.legal_copy_header)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"modal--body",domProps:{"innerHTML":_vm._s(_vm.explainer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }